import { Button } from "@risalabs_frontend_org/oasis-ui-kit";
import { useNavigate } from "react-router-dom";
import { InfoIcon } from "../../../svg/info-icon";

const InProgressComponent = () => {
  const navigate = useNavigate();
  return (
    <div className="error-container flex h-full w-full flex-col items-center justify-center gap-2">
      <div className="error-icon">
        <InfoIcon height={"48"} width={"48"} stroke={"#0056D6"} />
      </div>
      <div className="error-message text-center text-h11 font-semiBold text-primaryGray-1">
        Please wait while we retrieve the questionnaire. <br />
        You may revisit this page after a few minutes for the updated status.
      </div>
      <div className="error-message button mt-4">
        <Button
          disabled={false}
          onClick={() => navigate("/worklists")}
          buttonType={"primary"}
          size={"medium"}
        >
          Back to Home page
        </Button>
      </div>
    </div>
  );
};

export default InProgressComponent;
